import navbar from '@/components/NavBar.vue';
import Stepper from '@/components/wizardTreatment/stepper/index.vue';
import StepperNavigation from '@/components/wizardTreatment/stepper-navigation/index.vue';
import PlanCompost from '@/components/wizardTreatment/planCompost/index.vue';
import { mapState } from 'vuex';

export default {
  name: 'treatment-step-two',
  components: {
    navbar,
    Stepper,
    StepperNavigation,
    PlanCompost,
  },
  props: [],
  data() {
    return {

    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation']),
  },
  mounted() {

  },
  methods: {

  },
};
